/**
 * Leviathan Web - Quick Actions Widget
 * Quasar Prime LLC
 * Aggressive Tactical Industrial Design
 *
 * Grid of link buttons for common actions
 */

import { Link } from 'react-router-dom';
import { Package, Truck, FileText, Receipt } from 'lucide-react';

const actions = [
  { icon: <Package className="w-4 h-4" />, label: 'New Order', to: '/orders/new', color: 'amber' as const },
  { icon: <Truck className="w-4 h-4" />, label: 'New Dispatch', to: '/dispatch/new', color: 'steel' as const },
  { icon: <FileText className="w-4 h-4" />, label: 'New Invoice', to: '/invoices/new', color: 'steel' as const },
  { icon: <Receipt className="w-4 h-4" />, label: 'New Receipt', to: '/receipts/new', color: 'steel' as const },
];

const QuickActionsWidget = () => {
  return (
    <div className="h-full flex flex-col">
      <div className="flex items-center space-x-2 mb-3">
        <span className="text-[10px] uppercase tracking-[0.15em] text-text-secondary font-mono">
          Quick Actions
        </span>
      </div>

      <div className="grid grid-cols-2 gap-2 flex-1 content-start">
        {actions.map((action) => (
          <Link
            key={action.to}
            to={action.to}
            className={`flex items-center space-x-2 px-3 py-2.5 ${
              action.color === 'amber'
                ? 'bg-amber/10 hover:bg-amber/20 border-amber/30'
                : 'bg-steel/10 hover:bg-steel/20 border-steel/30'
            } border transition-colors rounded`}
          >
            <div className={action.color === 'amber' ? 'text-amber' : 'text-steel'}>
              {action.icon}
            </div>
            <span className="text-xs font-mono uppercase tracking-wide text-text-secondary">
              {action.label}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default QuickActionsWidget;
